export const CASE_STUDIES = [
  {
    id: 1,
    title: 'Echara',
    industry: 'HR & Payroll',
    year: '2024',
    logo: '/brand/echara.png',
    description: 'A human resource and employee management system covering the full employee lifecycle — staff records, leave and attendance, and automated payroll processing, all in one web platform.',
    tech: ['React', 'Node.js', 'PostgreSQL', 'Tailwind CSS'],
    metrics: [
      { label: 'Status', value: 'Live' },
      { label: 'Platform', value: 'Web' },
    ],
    results: 'Live platform serving active users',
    link: 'https://echara.cc',
    status: 'live',
  },
  {
    id: 2,
    title: 'Tap & Go',
    industry: 'Ride-hailing',
    year: '2023',
    logo: '/brand/tapandgo.png',
    description: 'A Zimbabwe-based ride-hailing mobile app connecting riders with nearby drivers for fast, affordable, cashless trips across the city.',
    tech: ['Mobile', 'Maps & Geolocation', 'Real-time Tracking', 'Payments'],
    metrics: [
      { label: 'Status', value: 'Live' },
      { label: 'Market', value: 'Zimbabwe' },
    ],
    results: 'Connecting riders and drivers nationwide',
    link: 'https://tapandgo.co.zw',
    status: 'live',
  },
  {
    id: 3,
    title: 'Connect Outsourcing',
    industry: 'HR & Outsourcing',
    year: '2024',
    logo: '/brand/connect-outsourcing.png',
    description: 'A corporate web platform for a Harare-based HR and business outsourcing firm — presenting their recruitment, payroll, and BPO services to clients across multiple continents.',
    tech: ['Web Platform', 'Responsive Design', 'SEO', 'CMS'],
    metrics: [
      { label: 'Status', value: 'Live' },
      { label: 'Reach', value: 'Global' },
    ],
    results: 'Live platform serving a global client base',
    link: 'https://www.connectoutsourcing.co.zw/',
    status: 'live',
  },
]
